// @flow
import React from "react";

import {connect} from "react-redux";
import {UnderTopBarThankYouFloater, ThankYouTitle, ThankYouContent} from "./ThankYouStyle";
import {strings, constants} from "../../../config";
import DownloadApp from "../../DownloadApp/DownloadApp";
import {getMobileOperatingSystemName} from "../../../Utils/AppUtils";
import GradientBackdropWithVan from "../../GradientBackdrop/GradientBackdropWithVan";

const getNativeAppDownloadLink = () => {
    if (!constants) {
        return null;
    }
    let deviceOS = getMobileOperatingSystemName();
    if (deviceOS === "iOS") {
        return constants.IOS_DOWNLOAD_LINK;
    }
    return constants.ANDROID_DOWNLOAD_LINK;
};

type OwnProps = {|
    offerAppDownload: boolean;
|};

const ThankYou = (props: OwnProps) => {
    return (
        <GradientBackdropWithVan>
            <UnderTopBarThankYouFloater offerAppDownload={props.offerAppDownload}>
                <ThankYouTitle>
                    {strings.thank_you_screen_title}
                </ThankYouTitle>
                { props.offerAppDownload ? 
                    <ThankYouContent>
                        {strings.thank_you_screen_content}
                    </ThankYouContent>
                    :
                    null
                }
                { props.offerAppDownload ? 
                    <DownloadApp onDownloadClick={() => {
                        window.location.href = getNativeAppDownloadLink();
                    }}/>
                    :
                    null
                }
            </UnderTopBarThankYouFloater>
        </GradientBackdropWithVan>
    );
};

const mapStateToProps = (state, props) => {
    return {};
};

export default connect(mapStateToProps)(ThankYou);



// WEBPACK FOOTER //
// ./src/Components/Screen/ThankYou/ThankYou.js